import React, { useCallback } from 'react';

import InventoryForm from '@/components/blocks/inventory/inventory-form';
import { useGlobalState } from '@/contexts/GlobalStateContext';
import type { InventoryUpdateSheetProps } from '@/types/module';

const InventoryUpdateSheet: React.FC<InventoryUpdateSheetProps> = ({
  product,
  onProductUpdated,
}) => {
  const { state, hideSheet } = useGlobalState();

  // Prefer product from props; fallback to any store-managed product if needed (legacy)
  const selectedProduct = product;

  // Resolve active sheet id for update aliases
  const getActiveSheetId = useCallback(() => {
    const aliases = ['inventory-update', 'edit-inventory', 'edit-product'];
    for (let i = state.sheets.length - 1; i >= 0; i--) {
      const s = state.sheets[i];
      if (aliases.includes(s.type)) return s.id;
    }
    return state.sheets[state.sheets.length - 1]?.id;
  }, [state.sheets]);

  const closeActiveSheet = useCallback(() => {
    const id = getActiveSheetId();
    if (id) hideSheet(id);
  }, [getActiveSheetId, hideSheet]);

  const handleSuccess = useCallback(async () => {
    closeActiveSheet();
    if (onProductUpdated) {
      await onProductUpdated();
    }
  }, [closeActiveSheet, onProductUpdated]);

  const handleCancel = useCallback(() => {
    closeActiveSheet();
  }, [closeActiveSheet]);

  return (
    <div className='py-2'>
      {selectedProduct && (
        <InventoryForm
          mode='update'
          product={selectedProduct}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
};

export default InventoryUpdateSheet;
